import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import ProfileCompletion from '../../common/ProfileCompletion';
import ProfileSuggestions from '../../common/ProfileSuggestions';
import InviteColleagues from '../../common/InviteColleagues';
import EditRoles from '../EditRoles';
import EditUser from '../EditUser';
import { getRequest, postRequest, deleteRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import { toRealNumber } from '../../../numberUtils';
import './UserSection.scss';
var nonFullViewName = function nonFullViewName(firstName, lastName, showHireAgain) {
  if (showHireAgain) {
    return [firstName, lastName].join(' ');
  }
  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName[0], ".");
  }
  if (firstName) {
    return "".concat(firstName);
  }
  return 'Name Omitted';
};
var name = function name(firstName, lastName, settingsUrl) {
  if (firstName || lastName) {
    return /*#__PURE__*/React.createElement("h1", {
      className: "fs-hide"
    }, "".concat([firstName, lastName].join(' ')));
  }
  return /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement("a", {
    tabIndex: 0,
    role: "button",
    href: settingsUrl
  }, "Add Name"));
};
var renderField = function renderField(attribute, icon, answer) {
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(attribute, " body-text-2 me-2")
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa ".concat(icon, " me-2")
  }), answer);
};
function hourlyRateText(_ref) {
  var low = _ref.low,
    high = _ref.high;
  if (low && high) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "demibold"
    }, "$", toRealNumber(low), ' ', "-", toRealNumber(high)), ' ', "/hour");
  }
  if (low || high) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "demibold"
    }, "$", low ? toRealNumber(low) : toRealNumber(high)), ' ', "/hour");
  }
  return null;
}
var projectProposals = function projectProposals(receivedProposals, fromProject) {
  return receivedProposals.find(function (p) {
    return p === fromProject;
  });
};
var UserSection = /*#__PURE__*/function (_Component) {
  function UserSection(props) {
    var _this;
    _classCallCheck(this, UserSection);
    _this = _callSuper(this, UserSection, [props]);
    var _this$props = _this.props,
      receivedProposals = _this$props.receivedProposals,
      fromProject = _this$props.fromProject;
    _this.state = {
      answers: null,
      favoriteId: props.favoriteId,
      proposalRequested: projectProposals(receivedProposals, fromProject) || false
    };
    _this.toggleSave = _this.toggleSave.bind(_this);
    _this.getAnswers = _this.getAnswers.bind(_this);
    _this.requestProposal = _this.requestProposal.bind(_this);
    return _this;
  }
  _inherits(UserSection, _Component);
  return _createClass(UserSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.getAnswers().then(function (response) {
        _this2.setState({
          answers: response.data
        });
      });
    }
  }, {
    key: "getAnswers",
    value: function getAnswers() {
      var _this$props2 = this.props,
        questionCategoryId = _this$props2.questionCategoryId,
        questionableId = _this$props2.questionableId,
        questionableType = _this$props2.questionableType,
        questionnaireName = _this$props2.questionnaireName;
      return getRequest('/question_answers/answers', {
        questionnaire_name: questionnaireName,
        question_category_id: questionCategoryId,
        questionable_id: questionableId,
        questionable_type: questionableType
      });
    }
  }, {
    key: "toggleSave",
    value: function toggleSave() {
      var _this3 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        csrfToken = _this$props3.csrfToken,
        searchEnabled = _this$props3.searchEnabled;
      var favoriteId = this.state.favoriteId;
      if (searchEnabled) {
        if (favoriteId) {
          deleteRequest("/user_favorites/".concat(favoriteId), csrfToken).then(function () {
            _this3.setState({
              favoriteId: null
            });
          });
        } else {
          postRequest('/user_favorites', {
            user_favorite: {
              favorited_id: id,
              favorited_type: 'ConsultantProfile'
            }
          }, csrfToken).then(function (response) {
            _this3.setState({
              favoriteId: response.data
            });
            analyticsTrack('Clicked Save on Profile View', {
              location: 'Consultant Profile Page'
            });
            window.location.href = '/users/favorites';
          });
        }
      }
    }
  }, {
    key: "requestProposal",
    value: function requestProposal() {
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        resourceId = _this$props4.resourceId,
        consultantInitials = _this$props4.consultantInitials,
        fromProject = _this$props4.fromProject;
      var toastMessage = "You requested a proposal from ".concat(consultantInitials, " Clora will be in touch shortly with next steps.");
      postRequest("/projects/".concat(fromProject, "/project_invitations"), {
        consultant_resource_id: resourceId,
        request_proposal: true
      }, csrfToken).then(function () {
        analyticsTrack('Clicked on Request Proposal', {
          location: 'Consultant Profile redirect from Project View',
          resource_id: resourceId
        });
      });
      toast.success(/*#__PURE__*/React.createElement("span", null, toastMessage));
      this.setState({
        proposalRequested: true
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props5 = this.props,
        searchEnabled = _this$props5.searchEnabled,
        showHireAgain = _this$props5.showHireAgain,
        uninvitedColleagues = _this$props5.uninvitedColleagues,
        invitedColleagues = _this$props5.invitedColleagues,
        hourlyRate = _this$props5.hourlyRate,
        query = _this$props5.query,
        resourceId = _this$props5.resourceId,
        csrfToken = _this$props5.csrfToken,
        inviteUrl = _this$props5.inviteUrl,
        inviterEmailDomain = _this$props5.inviterEmailDomain,
        fromProject = _this$props5.fromProject,
        firstName = _this$props5.firstName,
        lastName = _this$props5.lastName;
      var _this$state = this.state,
        favoriteId = _this$state.favoriteId,
        proposalRequested = _this$state.proposalRequested;
      var showCTA = showHireAgain || fromProject || searchEnabled;
      if (showCTA) {
        return /*#__PURE__*/React.createElement(Col, {
          xs: 12,
          md: 3,
          className: "text-center g-column"
        }, hourlyRate && hourlyRateText(hourlyRate), /*#__PURE__*/React.createElement(Fragment, null, showHireAgain && /*#__PURE__*/React.createElement("a", {
          href: "/users/".concat(resourceId, "/hire_again"),
          target: "_blank",
          className: "btn btn-primary get-connected profile-get-connected",
          onClick: function onClick() {
            analyticsTrack('Consultant hired again', {
              location: 'Consultant Profile Page',
              consultant: "".concat(firstName, " ").concat(lastName)
            });
          },
          type: "button",
          id: "hire-again",
          rel: "noreferrer"
        }, "Hire Again"), !showHireAgain && fromProject && /*#__PURE__*/React.createElement("a", {
          role: "button",
          type: "button",
          className: "btn btn-primary ".concat(proposalRequested ? 'disabled' : '', " get-connected profile-get-connected"),
          onClick: this.requestProposal,
          tabIndex: 0,
          id: "project-request"
        }, "Request Proposal"), !showHireAgain && !fromProject && searchEnabled && /*#__PURE__*/React.createElement("a", {
          href: "/users/".concat(resourceId, "/request_proposal?query_id=").concat(query),
          role: "button",
          type: "button",
          target: "_blank",
          className: "btn btn-primary ".concat(proposalRequested ? 'disabled' : '', " get-connected profile-get-connected"),
          onClick: function onClick() {
            analyticsTrack('Click Request Proposal on Profile', {
              location: 'Profile'
            });
          },
          tabIndex: 0,
          id: "search-request",
          rel: "noreferrer"
        }, "Request Proposal"), /*#__PURE__*/React.createElement("div", {
          className: "g-row--always g-row--centered"
        }, /*#__PURE__*/React.createElement(InviteColleagues, {
          disabled: false,
          location: "User Show View",
          invitedColleagues: invitedColleagues,
          uninvitedColleagues: uninvitedColleagues,
          csrfToken: csrfToken,
          resource: "Profile",
          resourceId: resourceId,
          inviteUrl: inviteUrl,
          handleFeedbacks: this.handleChange,
          styleType: "icon",
          styleClass: "fa fa-share-alt",
          cta: "Share",
          header: "Share with colleagues",
          subtext: "Send this profile to other team members and make a decision about this candidate.",
          ownerMessagePlaceholder: "How does this candidate fit your needs?...",
          limitInvitesWithinCompany: true,
          inviterEmailDomain: inviterEmailDomain,
          confirmationScreenAfterSend: true,
          preventCloseModalAfterSubmit: true
        }), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary-no-border",
          onClick: this.toggleSave,
          type: "button"
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(favoriteId ? 'fas' : 'far', " fa-heart")
        }), /*#__PURE__*/React.createElement("span", {
          className: "ps-3"
        }, "Save")))));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        firstName = _this$props6.firstName,
        lastName = _this$props6.lastName,
        settingsUrl = _this$props6.settingsUrl,
        editMode = _this$props6.editMode,
        fullView = _this$props6.fullView,
        csrfToken = _this$props6.csrfToken,
        questionableId = _this$props6.questionableId,
        questionableType = _this$props6.questionableType,
        questionCategoryId = _this$props6.questionCategoryId,
        questionnaireName = _this$props6.questionnaireName,
        userSectionQuestionnaireQuestions = _this$props6.userSectionQuestionnaireQuestions,
        rolesQuestionnaireQuestions = _this$props6.rolesQuestionnaireQuestions,
        updateCompletionPercentage = _this$props6.updateCompletionPercentage,
        togglePublic = _this$props6.togglePublic,
        isPublic = _this$props6.isPublic,
        percentage = _this$props6.percentage,
        sectionsNeedingAttention = _this$props6.sectionsNeedingAttention,
        availableNow = _this$props6.availableNow,
        ratingAvg = _this$props6.ratingAvg,
        reviewsLength = _this$props6.reviewsLength,
        rolesAvailable = _this$props6.rolesAvailable,
        showHireAgain = _this$props6.showHireAgain,
        suggestedTags = _this$props6.suggestedTags,
        updateSuggestedTags = _this$props6.updateSuggestedTags,
        showSuggestionModal = _this$props6.showSuggestionModal,
        userId = _this$props6.userId,
        onSectionClick = _this$props6.onSectionClick;
      var answers = this.state.answers;
      var role = answers && answers.find(function (a) {
        return a.question_key === 'Roles';
      });
      var suggestedTagCount = Object.keys(suggestedTags).reduce(function (sum, key) {
        return sum + suggestedTags[key].length;
      }, 0);
      var aboutNeedsAttention = sectionsNeedingAttention.some(function (section) {
        return section.question_category_id === questionCategoryId;
      });
      if (answers && answers.length > 0) {
        if (fullView) {
          return /*#__PURE__*/React.createElement("div", {
            className: "user-section",
            id: "question-category-".concat(questionCategoryId)
          }, /*#__PURE__*/React.createElement("div", {
            className: "profile-section"
          }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 12,
            md: 8
          }, /*#__PURE__*/React.createElement("div", {
            className: "g-row--always mb-2 "
          }, name(firstName, lastName, settingsUrl), aboutNeedsAttention && /*#__PURE__*/React.createElement("button", {
            type: "button",
            className: "attention-badge",
            "aria-label": "About needs attention",
            onClick: function onClick() {
              return onSectionClick(questionCategoryId);
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: "rating-avg"
          }, /*#__PURE__*/React.createElement("div", {
            className: "g-row--always"
          }, /*#__PURE__*/React.createElement(StarRatings, {
            rating: ratingAvg || 0,
            starRatedColor: "#EDA318",
            starHoverColor: "#EDA318",
            starDimension: "20px",
            starSpacing: "1px",
            numberOfStars: 5,
            name: "rating_avg"
          }), /*#__PURE__*/React.createElement("div", {
            className: "body-text-2 medium-weight avg"
          }, ratingAvg && toRealNumber(ratingAvg, 1) || 0), /*#__PURE__*/React.createElement("div", {
            className: "body-text-2"
          }, "(", reviewsLength, ' ', "review", reviewsLength === 1 ? '' : 's', ")")))), /*#__PURE__*/React.createElement("div", {
            className: "mb-2"
          }, role && rolesAvailable && /*#__PURE__*/React.createElement(EditRoles, {
            csrfToken: csrfToken,
            editMode: editMode,
            answers: answers,
            questionableId: questionableId,
            questionableType: questionableType,
            questionnaireQuestions: rolesQuestionnaireQuestions,
            questionnaireName: questionnaireName,
            getAnswers: this.getAnswers,
            updateCompletionPercentage: updateCompletionPercentage,
            suggestedTags: suggestedTags,
            updateSuggestedTags: updateSuggestedTags,
            showSuggestionModal: showSuggestionModal,
            fullView: fullView
          })), /*#__PURE__*/React.createElement("div", {
            className: "mb-2"
          }, answers && answers.find(function (a) {
            return a.question_key === 'Location';
          }) && /*#__PURE__*/React.createElement(EditUser, {
            csrfToken: csrfToken,
            editMode: editMode,
            answers: answers,
            questionableId: questionableId,
            questionableType: questionableType,
            questionnaireQuestions: userSectionQuestionnaireQuestions,
            questionnaireName: questionnaireName,
            getAnswers: this.getAnswers,
            updateCompletionPercentage: updateCompletionPercentage,
            suggestedTags: suggestedTags,
            updateSuggestedTags: updateSuggestedTags,
            showSuggestionModal: showSuggestionModal,
            userId: userId
          })), suggestedTagCount > 0 ? /*#__PURE__*/React.createElement(ProfileSuggestions, {
            tags: suggestedTagCount > 0,
            small: true
          }) : /*#__PURE__*/React.createElement(ProfileCompletion, {
            header: "Strengthen your profile!",
            subtext: "Rank higher, get more projects",
            percentage: percentage,
            sectionsNeedingAttention: sectionsNeedingAttention,
            onSectionClick: onSectionClick,
            small: true
          })), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 4,
            className: "d-none d-md-block"
          }, /*#__PURE__*/React.createElement("a", {
            role: "button",
            tabIndex: 0,
            id: "profile-page-make-".concat(isPublic ? 'private' : 'public', "-button"),
            className: "g-row--always g-row--between demibold",
            onClick: function onClick() {
              return togglePublic();
            }
          }, /*#__PURE__*/React.createElement("div", null, isPublic ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-lock-open"
          }) : /*#__PURE__*/React.createElement("i", {
            className: "fa fa-lock"
          }), isPublic ? 'Public Profile' : 'Private Profile'), /*#__PURE__*/React.createElement("div", {
            className: "switch"
          }, /*#__PURE__*/React.createElement("input", {
            type: "checkbox",
            checked: isPublic,
            readOnly: true
          }), /*#__PURE__*/React.createElement("span", {
            className: "slider round"
          }))), isPublic ? /*#__PURE__*/React.createElement("div", {
            className: "public-explanation body-text-3"
          }, "Employers on Clora can view your public profile. Your resume and other personally identifiable information won't be visible.") : /*#__PURE__*/React.createElement("div", {
            className: "private-explanation body-text-3"
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-exclamation-triangle"
          }), "Employers on Clora cannot view your profile.")))), /*#__PURE__*/React.createElement("div", {
            className: "d-block d-md-none d-lg-none"
          }, /*#__PURE__*/React.createElement("a", {
            role: "button",
            tabIndex: 0,
            id: "profile-page-make-".concat(isPublic ? 'public' : 'private', "-button"),
            className: "g-row--always g-row--between demibold",
            onClick: function onClick() {
              return togglePublic();
            }
          }, /*#__PURE__*/React.createElement("div", null, isPublic ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-lock-open"
          }) : /*#__PURE__*/React.createElement("i", {
            className: "fa fa-lock"
          }), isPublic ? 'Public Profile' : 'Private View'), /*#__PURE__*/React.createElement("div", {
            className: "switch"
          }, /*#__PURE__*/React.createElement("input", {
            type: "checkbox",
            checked: isPublic,
            readOnly: true
          }), /*#__PURE__*/React.createElement("span", {
            className: "slider round"
          })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 3,
            className: "d-none d-md-block"
          })));
        }
        var location = answers.find(function (a) {
          return a.question_key === 'Location';
        });
        var seniorities = answers.find(function (a) {
          return a.question_key === 'Role Level';
        });
        var yearsOfExperience = answers.find(function (a) {
          return a.question_key === 'Years Of Experience';
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "profile-section user-section"
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          xs: 12,
          md: 9
        }, /*#__PURE__*/React.createElement("div", {
          className: "g-row--always mb-2"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "fs-hide"
        }, nonFullViewName(firstName, lastName, showHireAgain)), ratingAvg && /*#__PURE__*/React.createElement("div", {
          className: "rating-avg"
        }, /*#__PURE__*/React.createElement("div", {
          className: "g-row--always align-items-center"
        }, /*#__PURE__*/React.createElement(StarRatings, {
          rating: ratingAvg,
          starRatedColor: "#EDA318",
          starHoverColor: "#EDA318",
          starDimension: "20px",
          starSpacing: "1px",
          numberOfStars: 5,
          name: "rating_avg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 medium-weight avg"
        }, toRealNumber(ratingAvg, 1)), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, "(", reviewsLength, ")"))), availableNow && /*#__PURE__*/React.createElement("span", {
          className: "available-now body-text-3"
        }, "Available Now")), /*#__PURE__*/React.createElement("div", {
          className: "level-yrs-location"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-2"
        }, role && rolesAvailable && /*#__PURE__*/React.createElement(EditRoles, {
          csrfToken: csrfToken,
          editMode: editMode,
          answers: answers,
          questionableId: questionableId,
          questionableType: questionableType,
          questionnaireQuestions: rolesQuestionnaireQuestions,
          questionnaireName: questionnaireName,
          getAnswers: this.getAnswers,
          updateCompletionPercentage: updateCompletionPercentage,
          suggestedTags: suggestedTags,
          updateSuggestedTags: updateSuggestedTags,
          showSuggestionModal: showSuggestionModal,
          fullView: fullView
        })), yearsOfExperience && yearsOfExperience.answer && renderField('years-of-experience', 'fa-id-card-alt', "".concat(yearsOfExperience.answer, " year").concat(yearsOfExperience.answer === 0 || yearsOfExperience.answer > 1 ? 's' : '', " of experience")), seniorities && seniorities.answer && seniorities.answer.length > 0 && renderField('seniorities', 'fa-certificate', seniorities.answer.map(function (a) {
          return a.label;
        }).join(', ')), location && location.answer && renderField('location', 'fa-map-marker-alt', location.answer))), this.renderActions()));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-section user-section"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-2 fs-hide"
      }, nonFullViewName(firstName, lastName, showHireAgain)), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight"
      }, "Loading..."));
    }
  }]);
}(Component);
UserSection.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  settingsUrl: PropTypes.string.isRequired,
  inviteUrl: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  fullView: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string.isRequired,
  questionCategoryId: PropTypes.number.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  userSectionQuestionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  rolesQuestionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCompletionPercentage: PropTypes.func.isRequired,
  rolesAvailable: PropTypes.bool.isRequired,
  resourceId: PropTypes.string.isRequired,
  togglePublic: PropTypes.func.isRequired,
  isPublic: PropTypes.bool.isRequired,
  percentage: PropTypes.number.isRequired,
  sectionsNeedingAttention: PropTypes.arrayOf(PropTypes.shape({})),
  onSectionClick: PropTypes.func,
  availableNow: PropTypes.bool.isRequired,
  hourlyRate: PropTypes.shape({}).isRequired,
  ratingAvg: PropTypes.number,
  reviewsLength: PropTypes.number.isRequired,
  searchEnabled: PropTypes.bool.isRequired,
  query: PropTypes.number,
  uninvitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  userId: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  favoriteId: PropTypes.number,
  inviterEmailDomain: PropTypes.string,
  showHireAgain: PropTypes.bool,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  fromProject: PropTypes.string,
  consultantInitials: PropTypes.string,
  receivedProposals: PropTypes.arrayOf(PropTypes.string)
};
hourlyRateText.propTypes = {
  low: PropTypes.string.isRequired,
  high: PropTypes.string.isRequired
};
UserSection.defaultProps = {
  firstName: null,
  lastName: null,
  sectionsNeedingAttention: [],
  onSectionClick: function onSectionClick() {},
  editMode: false,
  ratingAvg: null,
  favoriteId: null,
  query: null,
  inviterEmailDomain: '',
  showHireAgain: false,
  suggestedTags: {},
  updateSuggestedTags: function updateSuggestedTags() {},
  showSuggestionModal: '',
  uninvitedColleagues: [],
  fromProject: null,
  consultantInitials: null,
  receivedProposals: []
};
export default UserSection;